import React from "react";
import Layout from "../components/Layout";
import RbtDetailsPage from "../components/RbtDetailsPage";
import SidebarLayout from "../components/Sidebar";
import naturalImg from '../assets/natural.jpg'
import { useLocation } from "react-router-dom";


const Detalle = () => {

  const {state} = useLocation();

  return (                                                                                                                                                                                                                                                                                  
    <Layout>
      <SidebarLayout>
        <RbtDetailsPage
          rbtDetails={state}
        />
      </SidebarLayout>
    </Layout>
  );
};

export default Detalle;
